<template>
  <div class="app flex-row align-items-center animated fadeIn">
    <b-container>
      <b-img class="d-block mx-auto mb-3" src="/img/logo-full.png" fluid :alt="$t('shared.appLogo')"/>

      <div v-if="initializing" class="text-center">
        <font-awesome-icon spin icon="circle-notch" class="text-moremuted display-2"/>
      </div>
      
      <b-row v-else class="justify-content-center">
        <b-col
          :xl="registerViaPasswordEnabled ? '9' : '4'"
          :lg="registerViaPasswordEnabled ? '10' : '5'"
          :md="registerViaPasswordEnabled ? '12' : '6'"
        >
          <b-card-group>
            <b-card class="p-4">
              <login-via-password
                v-if="mode === 'loginViaPassword'"
                @setAccount="setAccount"
              />

              <login-via-otp
                v-else-if="mode === 'loginViaOtp'"
                @setAccount="setAccount"
              />

              <login-mode-changer v-model="mode"/>
            </b-card>

            <b-card
              v-if="registerViaPasswordEnabled"
              bg-variant="primary"
              class="p-4"
              body-class="d-flex flex-column text-center align-items-center justify-content-center"
            >
              <h2 class="mb-3">{{ $t('account.signUp') }}</h2>

              <p class="mb-3">{{ $t('account.signUpMessage') }}</p>

              <b-btn to="/register" variant="primary" class="active">{{ $t('account.registerNow') }}</b-btn>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import LoginViaPassword from './loginViaPassword'
import LoginViaOtp from './loginViaOtp'
import LoginModeChanger from './LoginModeChanger'
import * as types from '@/store/types'
import Settings from '@/mixins/settings/index'

export default {
  name: 'Login',
  components: {
    LoginViaPassword,
    LoginViaOtp,
    LoginModeChanger
  },
  mixins: [Settings],
  data () {
    return {
      initializing: true,
      mode: null
    }
  },
  mounted () {
    this.getSettings(`${this.$config.auth.userType}Account`)
    .then(() => {
      this.initializing = false
      this.mode = this.getDefualtMode()
    })
  },
  methods: {
    getDefualtMode () {
      if (this.loginViaPasswordEnabled)
        return 'loginViaPassword'

      else if (this.loginViaOtpEnabled)
        return 'loginViaOtp'
    },
    setAccount(user) {
      this.$store.commit(types.SET_ACCOUNT, {
        value: user,
        cookies: this.$cookies
      })
      
      const returnUrl = this.$route.query.returnUrl || this.$config.homeUrl
      this.$router.replace(returnUrl)
    }
  }
}
</script>
